import { createMemoryHistory, createHashHistory } from "history";

export default typeof document !== "undefined"
  ? createHashHistory()
  : createMemoryHistory({ initialEntries: ["/"] });



// WEBPACK FOOTER //
// ./services/history.js